/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { NavLink } from "react-router-dom";
import { ReactComponent as ContactIcon } from "cms/assets/icons/book.svg";
import { ReactComponent as TOLLogo } from "cms/assets/images/TOL-logo.svg";

const ContactColumn = () => {
    return (
        <div className='footer-column contact-column'>
            <NavLink to='https://www.tol.ca/en/index.aspx'>
                <TOLLogo />
            </NavLink>
            <ul>
                <li>
                    <ContactIcon />
                    <p>
                        Civic Facility<br />
                        20338 – 65 Avenue<br />
                        Langley, BC V2Y 3J1
                    </p>
                </li>
                <li>
                    <ContactIcon />
                    <p>
                        Phone: <NavLink to='https://www.tol.ca/en/connect/contact-us.aspx'>604-534-3211</NavLink>
                    </p>
                </li>
                <li>
                    <ContactIcon />
                    <NavLink to='https://www.tol.ca/en/connect/contact-us.aspx'>
                        Contact Us
                    </NavLink>
                </li>
            </ul>
        </div>
    );
};

export { ContactColumn };
